import { render } from "./FeatureEdit.vue?vue&type=template&id=fd0600ec&ts=true"
import script from "./FeatureEdit.vue?vue&type=script&lang=ts"
export * from "./FeatureEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__